import {
    A2sTemplate,
    AddLocaleInput,
    AssessmentDescriptor,
    AssessmentModule,
    AssessmentPrompt,
    AssessmentTemplate,
    AssessmentTemplateDefault,
    AssessmentTemplateMetadata,
    CreateAssessmentTypeInput,
    CreateModuleInput,
    CreateOrUpdateDefaultInput,
    CreatePromptInput,
    CreateTemplateInput,
    DeleteModuleInput,
    DeletePromptInput,
    GetTemplatesFilter,
    IsAcronymAvailableInput,
    PublishTemplateInput,
    ShareAssessmentTypeInput,
    ShareTemplateInput,
    UnshareAssessmentTypeInput,
    UnshareTemplateInput,
    UpdateDescriptorInput,
    UpdatePromptInput,
    UploadTemplateInput,
} from './generated/graphql';

export * from './generated/index';
export * from './generated/graphql';

/** Possible arguments for an incoming GraphQL request. This type allows for a single Lambda function to handle all requests  */
export type TemplateManagementArguments = {
    filter?: GetTemplatesFilter;
    input?:
        | UploadTemplateInput
        | CreateAssessmentTypeInput
        | IsAcronymAvailableInput
        | CreateTemplateInput
        | CreateModuleInput
        | DeleteModuleInput
        | CreatePromptInput
        | UpdatePromptInput
        | DeletePromptInput
        | UpdateDescriptorInput
        | AddLocaleInput
        | CreateOrUpdateDefaultInput
        | PublishTemplateInput
        | ShareTemplateInput
        | ShareAssessmentTypeInput
        | UnshareTemplateInput
        | UnshareAssessmentTypeInput;
};

/** Response type for AppSync handler. Collected from the queries/mutations of the schema files */
export type TemplateManagementResult =
    | string
    | boolean
    | AssessmentTemplate[]
    | A2sTemplate[]
    | AssessmentTemplateMetadata
    | AssessmentDescriptor
    | AssessmentPrompt
    | AssessmentModule
    | AssessmentTemplate
    | AssessmentTemplateMetadata[]
    | AssessmentTemplateDefault;
